// extracted by mini-css-extract-plugin
export default {"mobile":"(max-width: 360px)","rssArticleLinksUl":"RssArticleLinks_rssArticleLinksUl__8+K3Z"};